import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { post, get } from 'helpers/api_helper'
import { EMPLOYEE, BRANCH } from 'helpers/url_helper'
import Select from "react-select";
import { showSuccessAlert, showErrorAlert } from "helpers/alert_helper";

const BranchForm = ({cb = () => {}}) => {
    const [employees, setEmployees] = useState([]);
    const [formData, setFormData] = useState({
        name: '',
        branch_admin: null,
        email: '',
        contact_no: '',
        whatsp_app: '',
        address: '',
        city: '',
        state: '',
        country: '',
        pincode: ''
    });

    useEffect(() => {
        const getAllEmployees = async () => {
            const { success, data } = await get(`${EMPLOYEE}/options`);
            if(success){
                setEmployees(data);
            }
        }
        getAllEmployees();
    }, [])

    const handelSubmit = async(e) => {
        e.preventDefault();

        try{
            // Create JSON payload
            const payload = {
                name: formData.name,
                email: formData.email,
                contact_no: formData.phone,
                whatsp_app: formData.whatsp_app,
                branch_admin: formData.branch_admin ? formData.branch_admin.value : null,
                address: formData.address,
                city: formData.city,
                state: formData.state,
                country: formData.country,
                pincode: formData.pincode
            };
            const res = await post(BRANCH, payload);
            if(res.success){
                showSuccessAlert('branch created successfully', () => {
                    setFormData({
                        name: '',
                        email: '',
                        phone: '',
                        whatsp_app: '',
                        branch_admin: null,
                        address: '',
                        city: '',
                        state: '',
                        country: '',
                        pincode: ''
                    });
                });
                cb();
            } 
        } catch (error) {
            showErrorAlert(error.message || 'Failed to create branch');
        }
    };

    const handleBranchChange = (selectedOption) => {
        setFormData({
            ...formData,
            branch_admin: selectedOption
        });
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    }

    return (
        <Row>
            <Col>
                <Card>
                    <CardBody>
                        <h5 className="mb-3"> <i onClick={cb} className="fas fa-arrow-left me-3" role="button" title="Back to All Branches " /> New Branch</h5>
                        <hr />
                        <form onSubmit={handelSubmit}>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label htmlFor="name">Branch Name</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="name" 
                                            name="name" 
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            placeholder="Branch Name" 
                                            required 
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="name">Branch Admin</label>
                                        <Select
                                            value={formData?.branch_admin}
                                            onChange={handleBranchChange}
                                            options={employees}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="Select Branch Admin"
                                        />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="email">Email</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="email" name="email" value={formData?.email} placeholder="Email" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="phone">Phone</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="phone" name="contact_no" value={formData?.contact_no} placeholder="Phone" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="wp_phone">Whatsapp</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="wp_phone" name="whatsp_app" value={formData?.whatsp_app} placeholder="Whatsapp no" required />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="address">Address</label>
                                        <textarea onChange={handleInputChange} type="text" className="form-control" id="address" name="address" value={formData?.address} placeholder="Address" required />
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="city">City</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="city" name="city" value={formData?.city} placeholder="City" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="state">State</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="state" name="state" value={formData?.state} placeholder="State" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="country">Country</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="country" name="country" value={formData?.country} placeholder="Country" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="pincode">Pincode</label>
                                        <input onChange={handleInputChange} type="text" className="form-control" id="pincode" name="pincode" value={formData?.pincode} placeholder="Pincode" required />
                                    </div>
                                </Col>
                            </Row>
                            
                            <hr />
                            <Row className="text-end">
                                <Col>
                                    <button className="btn btn-danger me-2 " style={{width: '120px'}} type="button" onClick={cb}>Cancel</button>
                                    <button className="btn btn-primary" style={{width: '120px'}} type="submit">Submit</button>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                    
                </Card>
            </Col>
        </Row>
    );
}

export default BranchForm;